import { getData } from "Agentic Module/api/getData";
import { EMAIL_TRIAGE_BASE_URL } from "../emailTriaging/emailTriageApi";

const AGENT_ACTIVITY_TASKS = [
  { id: "scnc", name: "Alert Data", activityKey: "scnc_demand_check" },
  { id: "sap", name: "SAP Update", activityKey: "sap_po_pr_lookup" },
  { id: "tt", name: "T&T Tracking", activityKey: "track_trace_eta" },
  { id: "email", name: "Email Agent", activityKey: "email_triage" },
];

/** Resolve `alert_id` query param from RMPM `alertDetails` or dispatch row. */
export function resolveExplainAlertId(alertDetails) {
  if (!alertDetails || typeof alertDetails !== "object") return "";
  return String(
    alertDetails["Alert ID"] ?? alertDetails.alertId ?? alertDetails.alert_id ?? "",
  ).trim();
}

/** Normalize immediate_impact / downstream_risk (string legacy or { data, impact }). */
export function parseImpactBlock(value) {
  if (value == null) return { text: "", impact: "neutral" };
  if (typeof value === "string") {
    const text = value.trim();
    return { text, impact: "neutral" };
  }
  if (typeof value === "object") {
    return {
      text: String(value.data ?? "").trim(),
      impact: String(value.impact ?? "neutral").trim().toLowerCase() || "neutral",
    };
  }
  return { text: "", impact: "neutral" };
}

/** Normalize agent_activity entry (string[] legacy or { summary, data }). */
export function parseAgentActivityEntry(entry) {
  if (entry == null) return { summary: "", logs: [] };
  if (Array.isArray(entry)) {
    return { summary: "", logs: entry.map(String) };
  }
  if (typeof entry === "object") {
    return {
      summary: String(entry.summary ?? "").trim(),
      logs: Array.isArray(entry.data) ? entry.data.map(String) : [],
    };
  }
  return { summary: "", logs: [] };
}

/** Map `ai_agent_analysis` (+ nested `agent_activity`) to UI-ready shape. */
export function mapExplainAlertResponse(raw) {
  const analysis = raw?.ai_agent_analysis ?? raw ?? {};
  const activity = analysis.agent_activity ?? {};

  const tasks = AGENT_ACTIVITY_TASKS.map(({ id, name, activityKey }) => {
    const { summary, logs } = parseAgentActivityEntry(activity[activityKey]);
    return { id, name, summary, logs };
  });

  return {
    sectionSummary: String(analysis.section_summary ?? "").trim(),
    immediateImpact: parseImpactBlock(analysis.immediate_impact),
    downstreamRisk: parseImpactBlock(analysis.downstream_risk),
    supplyPipeline: String(analysis.supply_pipeline ?? "").trim(),
    historicalPattern: String(analysis.historical_pattern ?? "").trim(),
    riskAssessment: String(analysis.risk_assessment ?? "").trim(),
    tasks,
  };
}

/**
 * GET `/api/v1/explain-alert?alert_id={id}` — AI agent analysis for an alert.
 */
export async function fetchExplainAlert(alertDetails) {
  const alertId = resolveExplainAlertId(alertDetails);
  if (!alertId) {
    throw new Error("alert_id is required for explain-alert");
  }
  const url = `${EMAIL_TRIAGE_BASE_URL}/api/v1/explain-alert?alert_id=${encodeURIComponent(alertId)}`;
  const data = await getData(url);
  return mapExplainAlertResponse(data);
}
